import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShareModule } from 'src/app/share-module';
import { ComponentsModule } from 'src/app/components/components-module';
import { ChangePasswordDialogComponent } from './change-password-dialog/change-password-dialog.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConsentDialogComponent } from './consent-dialog/consent-dialog.component';
import { OptionsDialogComponent } from './options-dialog/options-dialog.component';
import { PaymentDialogComponent } from './payment-dialog/payment-dialog.component';
import { ProfileComponent } from './profile/profile.component';
import { SwitchProfileComponent } from './switch-profile/switch-profile.component';
import { VideoPlayerComponent } from './video-player/video-player.component';
import { MoreDialogComponent } from './more-dialog/more-dialog.component';
import { RateDialogComponent } from './rate-dialog/rate-dialog.component';
import { PersonInfoDialogComponent } from './person-info-dialog/person-info-dialog.component';
import { InputDialogComponent } from './input-dialog/input-dialog.component';
import { AvatarsDialogComponent } from './avatars-dialog/avatars-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        ShareModule,
        ComponentsModule
    ],
    declarations: [
        ChangePasswordDialogComponent,
        ConfirmDialogComponent,
        ConsentDialogComponent,
        OptionsDialogComponent,
        PaymentDialogComponent,
        ProfileComponent,
        SwitchProfileComponent,
        VideoPlayerComponent,
        MoreDialogComponent,
        RateDialogComponent,
        PersonInfoDialogComponent,
        InputDialogComponent,
        AvatarsDialogComponent
    ],
    entryComponents: [SwitchProfileComponent]
})

export class DialogsModule { }